export const strings = {
  title: 'Journals',
  all_journals: 'All Journals',
  my_journals: 'My Journals',
  attach_journals: 'Attach Journals',
  attach_journals_desc: 'Attach journal here which related to the case',
};
